<div class="bar" *ngIf="chartItems">
    <div *ngFor="let item of chartItems" class="bar-first single-bar" style="--count: {{chartItems.length}}">
        <!--setting width dynamically based on the total number of chart values-->
        <span class="count">{{item.GraphValue}}</span>
        <div class="bar-graph" style="height:{{item.ChartValue}}px" data-placement="top" data-toggle="tooltip"
             title="{{item.Title}}">
        </div>
        <span class="mt-2 small">{{item.Title}}</span>
    </div>
</div>
<div class="chart-axis">
    <div class="chart-y-axis"><p>{{max}}</p></div>
    <!--adding three horizontal line to bar chart for readability of bar value.-->
    <div class="chart-y-axis"></div>
    <div class="chart-y-axis"></div>
    <div class="chart-y-axis"></div>
    <div class="chart-y-axis"><p>0</p></div>
</div>
